import QRCode from 'qrcode'
import { publicOrigin } from '../platform/origin.ts'

/** The base the printed QR points to: the club's public origin (platform/origin.ts; never the native shell's own `capacitor://localhost`), or
 *  `VITE_LABEL_BASE_URL` when the labels must point elsewhere. A label outlives the app's address, so the READABLE tag is always printed too. */
export const labelBase = (): string => ((import.meta.env.VITE_LABEL_BASE_URL as string | undefined) ?? publicOrigin() ?? '').replace(/\/$/, '')
export const labelUrl = (tag: string, base = labelBase()): string => `${base}/a/${encodeURIComponent(tag)}`

export async function qrSvg(text: string): Promise<string> {
  return QRCode.toString(text, { type: 'svg', margin: 1, errorCorrectionLevel: 'M' })
}
/** Module matrix (true = dark), for tests and for rendering without an SVG round trip. */
export function qrMatrix(text: string): { size: number; get(x: number, y: number): boolean } {
  const q = QRCode.create(text, { errorCorrectionLevel: 'M' })
  return { size: q.modules.size, get: (x, y) => q.modules.get(x, y) === 1 }
}
